import { useAuthContext } from '../../common/contexts/auth';
import { useEnterprises } from '../../common/contexts/enterprises';
import {
  type SharedTestFilterData,
  type SharedTestParams
} from '../AxeDevtoolsProAnalytics';
import { useTest } from '../contexts/Test';
import type { Filters } from '@deque/axe-devtools-issues-utils';

export interface State {
  ready: boolean;
  data: SharedTestParams;
  testId?: string;
  filterData?: SharedTestFilterData;
}

interface Props {
  filters?: Filters;
}

const useSharedTestAnalyticsData = ({ filters }: Props = {}): State => {
  const { user, loading: userLoading } = useAuthContext();
  const { activeEnterprise, loading: enterpriseLoading } = useEnterprises();
  const { test, loading: testLoading, error, manifests } = useTest();

  let filterData;
  if (filters) {
    const manifest = Object.values(manifests || {})
      .flat()
      .find(m => m.id === filters.manifestId);

    filterData = {
      // when filter manifestId is set, we pass the guide name of the manifest as igtFilter
      igtFilter: manifest?.guide ? manifest.guide : filters.igt,
      configBestPractices: filters.configBestPractices,
      configNeedsReview: filters.configNeedsReview,
      severityFilter: filters.impact,
      bestPractices: filters.bestPractices,
      needsReview: filters.needsReview,
      automatic: filters.automatic,
      configAccessibilityStandard:
        filters.configAccessibilityStandard || filters.configWCAGLevel
    };
  }

  return {
    ready: !userLoading && !enterpriseLoading && !testLoading && !error,
    testId: test?.id,
    data: {
      testId: test?.id,
      isEnterprise: !!activeEnterprise,
      isCreator: !!test && !!user && test.creator_id === user.id,
      isLoggedIn: !!user
    },
    filterData
  };
};

export default useSharedTestAnalyticsData;
